module.exports = __webpack_public_path__ + "static/media/cover-photo-landing.a7cc26b9.png";